import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { authUserSetFollowMoveTo } from '../../../../../../../../rest/effects/authUser/authUserSetFollowMoveTo';
import { getUserFollowMoveTo } from '../../../../../../../../store/model/authUser/selectors/getUserFollowMoveTo';
import {
    SegmentCardEvent, SegmentCardOptions,
    segmentTrackAction
} from '../../../../../../../../middlewares/segment';
import {
    SegmentCardBooleanValue,
} from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onToggleFollow = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const isUserFollowMoveTo = getUserFollowMoveTo(getState());
        dispatch(authUserSetFollowMoveTo(!isUserFollowMoveTo));
        dispatch(segmentTrackAction(SegmentCardEvent.OPEN_MOVE_FOLLOW_CLICKED, {
            name: SegmentCardOptions.MOVE_TO_FOLLOW,
            value: isUserFollowMoveTo ? SegmentCardBooleanValue.FALSE : SegmentCardBooleanValue.TRUE,
        }));
    };
    return action;
};
